import { render, staticRenderFns } from "./RebarDetailing.vue?vue&type=template&id=2a36806d&scoped=true&"
var script = {}
import style0 from "./RebarDetailing.vue?vue&type=style&index=0&id=2a36806d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a36806d",
  null
  
)

export default component.exports